declare namespace $ {

	export class $mol_icon_navigation extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=navigation.view.tree.d.ts.map